/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { checkToken } from 'api/utils';

const NominasDescuentos = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [descuentos, setDescuentos] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _descuentos,
      ] = await Promise.all([
        getConfiguracionDescuentos(),
      ]);
      if (mounted) {
        setDescuentos(_descuentos);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const totalDescuentos = data.reduce((suma, actual) => suma + (actual?.importe_descuento || 0), 0);

  const columns = [
    {
      titleText: 'Descuentos',
      dataIndex: 'descuento',
      key: 'descuento',
      width: 250,
      render: (val) => {
        const _descuento = descuentos.find((e) => e.id === val);
        return `${_descuento?.clave} - ${_descuento?.concepto}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe_descuento',
      key: 'importe_descuento',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const summaryCells = [
    {
      label: 'Total',
      value: totalDescuentos,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          summaryCells={summaryCells}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default NominasDescuentos;
